import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OwnerLeadstatusesService {

  constructor(private http: HttpClient) { }

  getData(filter: any): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}owner_lead_statuses`, filter);
  }

  createData(data: any): Observable<object> {
    return this.http.post(`${environment.apiUrl}owner_lead_statuses/create`, data);
  }

  updateData(data: any): Observable<object> {
    return this.http.put(`${environment.apiUrl}owner_lead_statuses/update/${data._id}`, data);
  }

  deleteData(data: any): Observable<any> {
    return this.http.delete(`${environment.apiUrl}owner_lead_statuses/delete/${data._id}`, data);
  }

  getListData(filter: any): Observable<object> {
    return this.http.post<any[]>(`${environment.apiUrl}owner_lead_statuses`, filter);
  }
  getModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/get-exclusions?model=owner_lead-statuses`);
  }

  updateModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-exclusions`, data);
  }

  getAllModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/is-all-check?model=owner_lead-statuses`);
  }

  updateAllModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-all-exclusions`, data);
  }
}
